import React from 'react';
import { Stack, Typography } from '@mui/material';
import { SkullIcon } from '@wavetrak/theme';

interface Props {
  message?: string;
}

const LiveWindModalError: React.FC<Props> = ({ message = 'Error Loading Live Wind' }) => (
  <Stack justifyContent="center" alignItems="center" sx={{ width: 1, height: 1 }}>
    <SkullIcon />
    <Typography sx={{ mt: 2 }} variant="title3">
      {message}
    </Typography>
  </Stack>
);

export default LiveWindModalError;
